import { AccessRight } from '@cakedefi/cake-sdk';

export function isCountryRestricted(accessRight: AccessRight): boolean {
  return !accessRight.access && accessRight.reasons?.includes('CountryRestriction');
}
